import 'bootstrap/dist/css/bootstrap.min.css';

import { Redirect, Route, Switch } from 'react-router';

import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ScrollToTop from './components/common/ScrollToTop';

import Home from './components/pages/Home';
import About from './components/pages/About';
import Projects from './components/pages/Projects';
import ProjectDetail from './components/pages/ProjectDetail';
import Gallery from './components/pages/Gallery';
import Clients from './components/pages/Clients';
import Contact from './components/pages/Contact';

function App() {
  return (
    <>
    <ScrollToTop />
      <Header />
      <main id="main-content">
      <Switch>
        <Route exact path="/" component={Home} ></Route>
        <Route exact path="/about" component={About}></Route>
        <Route exact path="/projects" component={Projects}></Route>
        <Route exact path="/project/:id" component={ProjectDetail}></Route>
        <Route exact path="/gallery" component={Gallery}></Route>
        <Route exact path="/clients" component={Clients}></Route>
        <Route exact path="/contact" component={Contact}></Route>
        <Redirect to="/" />
      </Switch>
      </main>
      <Footer />
    </>
  );
}

export default App;
